/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Supported deductible values in euro.   (german: Selbstbeteiligung)
 */
export const PrivateLiabilityDeductible = {
  None: 'None',
  _150: '150',
  _300: '300',
  _500: '500',
  _1000: '1000',
} as const;
export type PrivateLiabilityDeductible = (typeof PrivateLiabilityDeductible)[keyof typeof PrivateLiabilityDeductible];
